module.exports = __webpack_public_path__ + "img/hieu-pro.7ef7a6de.jpg";